import withPopup from './with-popup';

export default withPopup;
